export const BrowserSessionName = 'tokens-browser';
export const BrowserSessionType = 'tokenData';
